import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c7e6fc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TheMap" }
const _hoisted_2 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_3 = { class: "TheMap__container mt-3" }
const _hoisted_4 = {
  key: 0,
  class: "TheMap__state"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Загрузка карты...", -1))
const _hoisted_6 = {
  key: 1,
  class: "TheMap__state"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "Ошибка при загрузке карты", -1))
const _hoisted_8 = ["id"]
const _hoisted_9 = {
  key: 1,
  class: "TheMap__state"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Карта скрыта", -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio_group = _resolveComponent("radio-group")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["TheMap__header", {
                'justify-between': _ctx.twoGis && _ctx.isMapLoaded,
                'justify-end': !_ctx.twoGis || !_ctx.isMapLoaded,
            }])
    }, [
      (_ctx.twoGis && _ctx.isMapLoaded)
        ? (_openBlock(), _createBlock(_component_radio_group, {
            key: 0,
            class: "small",
            options: _ctx.MAP_LAYERS,
            "select-by": "value",
            value: _ctx.state.layer,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.layer) = $event)),
            onChange: _ctx.switchMap
          }, null, 8, ["options", "value", "onChange"]))
        : _createCommentVNode("", true),
      (_ctx.isCanHide)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.state.is_opened)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 0,
                  class: "primary small text",
                  onClick: _ctx.closeMap
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Скрыть ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_the_button, {
                  key: 1,
                  class: "primary small text",
                  onClick: _ctx.openMap
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Открыть ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.state.is_loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_loader, { class: "primary mt-1" })
          ]))
        : (_ctx.state.is_failed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_the_button, { class: "primary small mt-2" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Перезагрузить ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["TheMap__section", { opened: _ctx.isMapShowed }])
      }, [
        (_ctx.isMapShowed)
          ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("section", { id: _ctx.mapId }, null, 8, _hoisted_8), [
          [_vShow, _ctx.isMapShowed]
        ]),
        (!_ctx.state.is_opened)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}